module.exports = __webpack_public_path__ + "media/images/logo-blank-9026799d6abae2b0ce56100bfa702294.svg";